/**
 * Global PWA install prompt singleton.
 *
 * The `beforeinstallprompt` event fires very early — often before React has
 * mounted any component. By capturing it here at module-evaluation time we
 * guarantee it is never missed, regardless of which page the user lands on or
 * navigates to via the SPA router.
 */

let _promptEvent = null
const _listeners = new Set()

function notify() {
  _listeners.forEach(fn => fn(_promptEvent))
}

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  _promptEvent = event
  notify()
})

window.addEventListener('appinstalled', () => {
  _promptEvent = null
  notify()
})

export function getPWAPrompt() {
  return _promptEvent
}

export function subscribePWAPrompt(fn) {
  _listeners.add(fn)
  // Immediately call with current value so late subscribers don't miss it
  fn(_promptEvent)
  return () => _listeners.delete(fn)
}

export async function triggerPWAInstall() {
  if (!_promptEvent) return false
  _promptEvent.prompt()
  const { outcome } = await _promptEvent.userChoice
  _promptEvent = null
  notify()
  return outcome === 'accepted'
}
